import { Navigate, Outlet, useLocation } from 'react-router-dom';
import authService from 'api/auth.service';

/**
 * AuthGuard: Protects routes that require authentication
 * If user is not authenticated, redirects to login page
 */
const AuthGuard = () => {
  const isAuthenticated = authService.isAuthenticated();
  const location = useLocation();

  if (!isAuthenticated) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  return <Outlet />;
};

export default AuthGuard;
